var _defs, _g, _g2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVarlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_43",
    "data-name": "Component 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.439,
    height: 65.275,
    viewBox: "0 0 143.439 65.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.017,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#e8f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#e8f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3fafd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(69.008 1.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M344.9,348.012a3.7,3.7,0,0,1-3.3-2.021l-11.425-22.372-12.288,22.465a3.705,3.705,0,0,1-3.25,1.927h-.027a3.705,3.705,0,0,1-3.249-1.975l-15.769-29.854a3.705,3.705,0,0,1,6.552-3.461l12.55,23.76,12.344-22.566a3.7,3.7,0,0,1,3.25-1.927h.053a3.705,3.705,0,0,1,3.247,2.02L348.2,342.621a3.706,3.706,0,0,1-3.3,5.391Z",
    transform: "translate(-295.164 -310.746)",
    fill: "#43afe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M351.769,347.879a2.952,2.952,0,0,1-1.865-.662L339.648,338.9a2.964,2.964,0,0,1,.111-4.69l11.745-8.64v-8.136h-26.66c-1.042-1.8-2.552-5.928-4.446-5.928h34.07a2.964,2.964,0,0,1,2.964,2.964v12.6a2.964,2.964,0,0,1-1.208,2.388l-9.862,7.255,7.276,5.9a2.964,2.964,0,0,1-1.869,5.266Z",
    transform: "translate(-283 -310.379)",
    fill: "#2f77b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 3.679,
    cy: 3.679,
    r: 3.679,
    transform: "translate(31 22.586)",
    fill: "#2f77b6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-human-2428014",
    transform: "translate(5.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M179.963,42.423a7.765,7.765,0,1,1,5.491-2.274A7.768,7.768,0,0,1,179.963,42.423Zm25.187-.756a4.3,4.3,0,0,0-5.445-2.19l-10.444,4.306h0a15.245,15.245,0,0,1-5.2.919h-8.188a15.245,15.245,0,0,1-5.2-.919l-10.407-4.292a4.3,4.3,0,0,0-5.445,2.19,4.139,4.139,0,0,0,2.387,5.51l10.064,4.167A4.161,4.161,0,0,1,170,55.271v7.51a4.164,4.164,0,0,1-.255,1.46L160.258,83.6a4.291,4.291,0,0,0,2.19,5.444,4.138,4.138,0,0,0,5.51-2.387l8.1-15.619a4.159,4.159,0,0,1,7.81,0l8.072,15.393a4.3,4.3,0,0,0,5.175,2.759,4.131,4.131,0,0,0,2.671-5.379l-9.605-19.6a4.161,4.161,0,0,1-.255-1.46V55.272a4.161,4.161,0,0,1,2.737-3.912l10.1-4.182a4.138,4.138,0,0,0,2.387-5.51Z",
    transform: "translate(-154.481 -26.892)",
    fill: "#2f77b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(2.136 25.124)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 57.757,
    height: 20.737,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M348.226,113.355l-.175,1.816a10.612,10.612,0,0,1-3.62,1.614c-1.332.079-1.462-.584-1.4-1.131s0-1.566-.76-1.579-1.45.81-1.541,1.86,0,2.81,1.23,3.317,4.244,0,4.244,0,1.689-.5,1.848.184-.914,1.155-.914,1.155a16.419,16.419,0,0,1-4.867,1c-2.046-.047-.952-.873-.885-1.33s-.068-.841-1.157-.827-1.246,1.4-1.169,1.946a2.794,2.794,0,0,0,2.117,2.346,26.553,26.553,0,0,0,5.028-.282s2.042-.431,2.023.282-.194,1.355-1.089,1.463-3.549.886-4.37.652-1.935-.975-1.766-1.4-1.541-.5-1.532.185a4.015,4.015,0,0,0,1.706,3.037c1.188.644,6.419.878,6.876.325s0,2.508,0,2.508-.015.475-.914-.262-4.9-.65-5.753.262-.682,2.723,0,2.883,1.386.456,1.645.168-.173-2.016.97-1.688,3.786,1.563,5.04,2.125,4.676-1.258,4.676-1.258,2.308-2.074,2.308-.868.409,1.852,1.248,1.688a1.5,1.5,0,0,0,1-2.319,3.443,3.443,0,0,0-3.79-1.44c-1.9.395-3.359,1.658-3.684,1.44s-.425-3.491,0-3.24a7.584,7.584,0,0,0,4.952.6c2.373-.562,3.273-1.635,3.57-2.952s-.463-1.754-1.433-1.194-.548,1.455-1.859,1.4-4.884-.116-5.229-.652c.042-.714,0-1.745,0-1.745a13.237,13.237,0,0,0,4.4.69c2.014-.139,3.086-.408,4.118-1.292s.653-2.975.488-3.229-1.548-.786-1.92.318-.3,1.562-1.5,1.45-4.294-.791-4.294-.791l-1.293-.658v-1.05a9.735,9.735,0,0,0,4.952.554c2.129-.55,2.728-2.028,2.522-3.031s-.4-2.264-1-2.329a1.069,1.069,0,0,0-1.248.814c-.074.559.451,1.757-.278,1.9a13.347,13.347,0,0,1-3.044-.381l-1.908-1.055v-1.994Z",
    transform: "translate(-320.647 -113.355)",
    fill: "rgba(58,134,255,0.25)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 62.249,
    height: 2.246,
    rx: 1.123,
    transform: "translate(0 23.841)",
    fill: "#43afe9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 62.249,
    height: 2.246,
    rx: 1.123,
    transform: "translate(0 44.377)",
    fill: "#43afe9"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Clinic",
    transform: "translate(67.231 60.275)",
    fill: "#2f77b6",
    fontSize: 19,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLINIC"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarlogo);
export default __webpack_public_path__ + "static/media/varlogo.8bb6b293ba523678c6fdbb7c133f88a4.svg";
export { ForwardRef as ReactComponent };